module.exports = __webpack_public_path__ + "img/caioColor.b5109080.png";